import axios from "axios";

const api = process.env.REACT_APP_API;
const editDelivery = async (body) => {
  try {
    const response = await axios.post(`${api}delivery/edit`, body);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export { editDelivery };
